import { Injectable, NgZone, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MeritProcessType } from '../enums/merit-process-type.enum';

interface MeritProcessTypeStateModel {
  selectedProcessType: MeritProcessType;
}

// Auto-migrated from NGXS
@Injectable({ providedIn: 'root' })
export class MeritProcessTypeState {
  private readonly ngZone = inject(NgZone);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  private readonly meritProcessTypeStateModel = signal<MeritProcessTypeStateModel>({
    selectedProcessType: MeritProcessType.Merit
  });

  public selectedProcessType = computed(() => this.meritProcessTypeStateModel().selectedProcessType);
  public isMerit = computed(() => this.selectedProcessType() === MeritProcessType.Merit);
  public isIncentive = computed(() => this.selectedProcessType() === MeritProcessType.Incentive);

  setMeritProcessType(payload: MeritProcessType = MeritProcessType.Merit): void {
    this.meritProcessTypeStateModel.update(state => ({ ...state, selectedProcessType: payload }));
  }

  setMeritProcessTypeWithRouterChange(payload: MeritProcessType = MeritProcessType.Merit): void {
    this.setMeritProcessType(payload);
    this.ngZone.run(
      function (this: Router, navigationExtras): Promise<boolean> {
        return this.navigate([], navigationExtras);
      },
      this.router,
      [{ relativeTo: this.activatedRoute, queryParams: { processType: payload }, queryParamsHandling: 'merge' }]
    );
  }
}
